import globalConfig from './globalConfig';
const mainHost = globalConfig.getMainHost();
const DEFAULT_ICON_NAME = {
  'blancozone.com': 'white',
};

export const getProductDefaultImg = type => {
  return `https://gabres.${mainHost}/commonImg/storeDefault/product_${
    type || 'package'
  }${DEFAULT_ICON_NAME[mainHost] ? '_' + DEFAULT_ICON_NAME[mainHost] : ''}.png`;
};
